<template>
  <div class="overall-bg p-0">
    <b-container>
      <b-row class="tabviewtable">
        <b-col>
          <div class="form-white-bg" v-if="windowWidth > 545">
            <b-row>
              <div class="chip_class" v-if="filterItemsArray && filterItemsArray.length > 0">
                <div class="">
                  <div class="filter_chip" v-if="filterItemsArray[0]['Date'] !== ''">
                    <span>Date: {{ filterItemsArray[0]["Date"] }}</span>
                    <span @click="removeChip('Date')"><i class="pi pi-times"></i>
                    </span>
                  </div>
                  <div class="filter_chip" v-if="filterItemsArray[0]['Code'] !== ''">
                    <span>Code: {{ filterItemsArray[0]["Code"] }}</span>
                    <span @click="removeChip('Code')"><i class="pi pi-times"></i>
                    </span>
                  </div>
                  <div class="filter_chip" v-if="filterItemsArray[0]['StatusName'] != ''">
                    <span>Status: {{ filterItemsArray[0]["StatusName"] }}</span>
                    <span @click="removeChip('StatusName')"><i class="pi pi-times"></i>
                    </span>
                  </div>
                  <div class="filter_chip" v-if="filterItemsArray[0]['ApprovalStatusNames'] != ''">
                    <span>Approval Status:
                      {{ filterItemsArray[0]["ApprovalStatusNames"] }}</span>
                    <span @click="removeChip('ApprovalStatusNames')"><i class="pi pi-times"></i>
                    </span>
                  </div>
                </div>
                <div class="">
                  <button class="btn resetallfilter me-2 rounded-pill float-end" @click="ResetFilter">
                    Clear all
                  </button>
                </div>
              </div>
              <b-col :lg="visible ? '3' : '0'" v-if="items.length !== 0">
                <b-collapse id="collapse-1" class="mt-2" v-model="visible">
                  <FilterForm :sidedisplay="true" @FilterValues="Filter" @ResetValues="ResetFilter"
                    :ClearDateFilter="SearchValue" v-if="FilterLoading">
                    <template v-slot:filterslot>
                      <itemIssueGrnReturnFilters @updatedcode="Emitcode" :removechiptype="removechipvalue"
                        :itemsList="items" />
                      <poGrnFilters :showFields="false" @StatusNames="EmitStatus" @StatusIds="EmitStatusId"
                        @ApprovalStatusName="EmitAppstatus" @ApprovalStatusIds="EmitApprovalStatusIds"
                        :StatusFilter="StatusFilter" :resetfilter="resetfilter" />
                    </template>
                  </FilterForm>
                </b-collapse>
              </b-col>
              <b-col :lg="items.length !== 0 && visible ? '9' : '12'">
                <SkeletonTableLoader :columns="headers" :loading="loading" />
                <div v-if="!loading">
                  <MasterEmpty v-if="
                    items.length === 0 &&
                    !SearchValue.inputValue &&
                    !SearchValue.fromDate &&
                    !SearchValue.toDate &&
                    !hasData
                  " eheader="Purchase Request" econtent="Purchase Request" eimg="/src/assets/Img/icons/sub-tax.svg"
                    @createNew="IsCreate" />
                  <Tableview v-if="
                    items.length !== 0 ||
                    SearchValue.inputValue ||
                    SearchValue.fromDate ||
                    SearchValue.toDate ||
                    hasData
                  " :value="items" class="p-datatable-gridlines commonstatusclass" :rows="10" dataKey="Id"
                    :rowHover="true" filterDisplay="menu" :loading="loading1" responsiveLayout="scroll"
                    :columns="headers" :globalFilterFields="globalFilterFields" :filters="filters" @row-click="RowClick"
                    :totalRecords="rowsCount" :state="state" @ShowRows="ShowRows" :searchbox="false" :searchbox1="true"
                    @search="SearchBox" :exceldownload="true" :filterbtn="true" :statusFilterBtn="true"
                    :showColumnFilters="false">
                    <template v-slot:statusFilterBtn>
                      <div class="filterBtnStatus d-flex align-items-center">
                        <div class="filter_chip1" :class="{
                          'selected-chip': item.id === selectedStatus,
                        }" v-for="item in filterStatus" :key="item.id" @click="selectStatus(item.id, item.name)">
                          <p>
                            {{ item.name }}
                          </p>
                        </div>
                      </div>
                    </template>
                    <template v-slot:exceldownload>
                      <ExportOption @ExportExcel="ExportExcel" @ExportPDF="ExportPDF" :ExportList="ExportList"
                        :PageName="PageName" :ExportOption="ExportOption" class="ms-2" :HideAndShow="true" />
                    </template>

                    <template v-slot:filter>
                      <i class="pi pi-filter tablefilter" :class="visible ? null : 'collapsed'"
                        :aria-expanded="visible ? 'true' : 'false'" aria-controls="collapse-4"
                        @click="visible = !visible"></i>
                    </template>

                    <template v-slot:waitingsince="{ data }">
                      <p>
                        {{
                          data.Status == "1" ? "-" : waitingtime(data.DocDateHR)
                        }}
                      </p>
                    </template>

                    <template v-slot:Add>
                      <span class="add">
                        <AddButton @click="IsCreate()" :btnname="$t('btn.plusaddnew')"></AddButton>
                      </span>
                    </template>
                    <template v-slot:status="{ data }">
                      <RedStatus name="Draft" v-if="data.Status == 0 && data.IsDraft == '1'" />
                      <OrangeStatus name="Pending" v-if="data.Status == 0 && data.IsDraft != '1'" />
                      <BlueStatus name="Converted To PO" v-if="data.Status == 1 && data.IsDraft != '1'" />
                      <BlueStatus name="Partial PO" v-if="data.Status == 2 && data.IsDraft != '1'" />
                      <RedStatus name="Closed" v-if="data.Status == 3" />
                      <div v-if="data.Status == 3">
                        <span for="">Reason: {{ data?.ClosedReason }}</span>
                      </div>
                      <RedStatus name="Cancelled" v-if="data.Status == 4" />
                      <div v-if="data.Status == 4">
                        <span for="">Reason: {{ data?.CancelReason }}</span>
                      </div>
                      <GreenStatus name="Converted To GRN" v-if="data.Status == 5" />
                      <BlueStatus name="Converted To GRN Partial" v-if="data.Status == 6" />

                      <!-- <RedStatus name="Draft" v-if="data.PRStatus == '0' && data.IsDraft == '1'" />
                      <OrangeStatus name="Pending"
                        v-if="(data.PRStatus == '0' && data.Status == '0' && data.IsDraft != '1') || (data.PRStatus == '1' && data.Status == '0' && data.IsDraft == '0')" />

                      <BlueStatus name="Converted To PO"
                        v-if="data.PRStatus != '2' && data.Status == '1' && data.IsDraft != '1'" />
                      <BlueStatus name="Partial PO" v-if="data.PRStatus == '2' && data.Status == '0'" />

                      <RedStatus name="Closed" v-if="data.PRStatus == '3'" />
                      <div v-if="data.PRStatus == '3'">
                        <span for="">Reason: {{ data?.ClosedReason }}</span>
                      </div>
                      <RedStatus name="Cancelled" v-if="data.PRStatus == '4'" />
                      <div v-if="data.PRStatus == '4'">
                        <span for="">Reason: {{ data?.CancelReason }}</span>
                      </div>
                      <GreenStatus name="Converted To GRN" v-if="data.Status == '5'" />
                      <BlueStatus name="Converted To GRN Partial" v-if="data.Status == '6'" /> -->
                    </template>

                    <template v-slot:ApprovalStatus="{ data }">
                      <div v-if="data.IsDraft == '1'">
                        <span>-</span>
                      </div>
                      <div v-else>
                        <OrangeStatus name="Pending" v-if="data.IsApproved == '0' || data.IsApproved == '2'" />
                        <GreenStatus name="Approved" v-if="data.IsApproved == '1'" />
                        <RedStatus name="Declined" v-if="data.IsApproved == '3'" />
                      </div>
                    </template>

                    <template v-slot:action="{ data }">
                      <span>
                        <Button icon="pi pi-ellipsis-v" class="p-button-rounded editicon p-button-text"
                          @click="toggle($event, data)" />
                      </span>
                    </template>
                  </Tableview>
                </div>
              </b-col>
            </b-row>
          </div>
          <div v-if="windowWidth <= 545">
            <MobileLoader v-if="loading" />
            <div v-if="!loading">
              <MasterEmpty v-if="
                items.length === 0 &&
                !SearchValue.inputValue &&
                !SearchValue.fromDate &&
                !SearchValue.toDate
              " eheader="Purchase Indent" econtent="Purchase Indent" eimg="/src/assets/Img/icons/sub-tax.svg"
                @createNew="IsCreate" />
              <MobileViewCardHeader @search="SearchBox" v-if="
                items.length !== 0 ||
                SearchValue.inputValue ||
                SearchValue.fromDate ||
                SearchValue.toDate
              ">
                <template v-slot:mobilecard>
                  <div class="mobile-card" v-for="item in items" @click="RowClick(item)">
                    <div class="d-flex align-items-center justify-content-between">
                      <div class="d-flex align-items-center gap-1">
                        <p class="light-name">{{ item["DocNo"] }} /</p>
                        <p class="light-name">{{ item["DocDate"] }}</p>
                      </div>
                      <i class="pi pi-ellipsis-v" @click.stop="toggle($event, item)"></i>
                    </div>
                    <div class="d-flex align-items-center gap-2">
                      <p class="light-name">Item count :</p>
                      <p class="small-name">{{ item["ItemCount"] }}</p>
                    </div>
                    <div class="d-flex align-items-center gap-2">
                      <p class="light-name">Item value :</p>
                      <p class="small-name">{{ item["Amount"] }}</p>
                    </div>
                  </div>
                </template>
              </MobileViewCardHeader>
            </div>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>

  <Dialog v-model:visible="ObjCancelPopUp.CancelReasonPopup" modal :header="ObjCancelPopUp.PopUpHeaderName"
    :breakpoints="{
      '1980px': '55vw',
      '1440px': '60vw',
      '960px': '70vw',
      '640px': '90vw',
    }" class="overall-bg">
    <b-container fluid>
      <b-row>
        <b-col>
          <div class="field">
            <Textarea :name="ObjCancelPopUp.TextAareaName" :label="ObjCancelPopUp.TextAareaName"
              :rules="{ required: false }" :id="ObjCancelPopUp.TextAareaName" v-model="ObjCancelPopUp.CancelReason" />
            <Footer class="p-3" @cancel="ObjCancelPopUp.CancelReasonPopup = false" @save="SaveCancelPR" />
          </div>
        </b-col>
      </b-row>
    </b-container>
  </Dialog>

  <Dialog v-model:visible="ObjPRClosePopUp.Visible" modal :header="ObjPRClosePopUp.PopUpHeaderName" :breakpoints="{
    '1980px': '55vw',
    '1440px': '60vw',
    '960px': '70vw',
    '640px': '90vw',
  }" class="overall-bg">
    <b-container fluid>
      <b-row>
        <b-col>
          <div class="field">
            <Textarea :name="ObjPRClosePopUp.TextAareaName" :label="ObjPRClosePopUp.TextAareaName"
              :rules="{ required: false }" :id="ObjPRClosePopUp.TextAareaName" v-model="ObjPRClosePopUp.ClosedReason" />
            <Footer class="p-3" @cancel="ObjPRClosePopUp.Visible = false" @save="SaveClosePR" />
          </div>
        </b-col>
      </b-row>
    </b-container>
  </Dialog>

  <Menu ref="menu" id="overlay_menu" :model="itemListed" @click="" :popup="true" />
  <DeletedSuccessfully :visible="deletepop" @ok="deletepop = false" />
  <DeleteConfirmationVue :DeleteModel="Deletemodel" :content="content" @yes="IsDelete(DataEdit)"
    @no="Deletemodel = false" />
  <EditConfirmation :Editmodel="Editmodel" @yes="IsEdit(DataEdit)" @no="Editmodel = false"
    :content="$t('confirmation.editcontent')" />
  <POConfirmation :Editmodel="POmodel" @yes="ConverToPO(DataEdit)" @no="POmodel = false"
    content="Do you want to Convert To PO?" />
  <ClosedSuccessfully :content="ModelPopupDunction.CloseModelTxt" :visible="ModelPopupDunction.CloseSuccessPop"
    @ok="Close()" />

  <CloseConfirmation :Editmodel="ModelPopupDunction.CloseConfirmPop" @yes="UpdateCloseStatus()"
    @no="ModelPopupDunction.CloseConfirmPop = false" :header="ObjPRClosePopUp.ConfirmPopupHeader"
    :content="ObjPRClosePopUp.ConfirmPopupContent" />

  <CancelSuccessfully :content="ModelPopupDunction.CancelModelTxt" :visible="ModelPopupDunction.Cancelpop"
    @ok="cancelclose()" />
  <RevertedSuccessfully :content="ModelPopupDunction.RevertModelTxt" :visible="ModelPopupDunction.Revertpop"
    @ok="cancelclose()" />
  <CancelConfirmation :Editmodel="ModelPopupDunction.cancelmodel" @yes="UpdateCancelStatus()"
    @no="ModelPopupDunction.cancelmodel = false" :header="ObjCancelPopUp.ConfirmPopupHeader"
    :content="ObjCancelPopUp.ConfirmPopupContent" />

  <CrystalReportPrintPopUp :ShowAndHide="CrystalReportPopup" :ParameterValues="ParameterValues" :PrintType="PrintType"
    @closepopup="hidepopup" />

  <Toast />
</template>
<script lang="ts">
import {
  defineComponent,
  ref,
  computed,
  onMounted,
  watch,
  reactive,
  onUnmounted,
} from "vue";
import Tableview from "../../../../../components/FormComponents/Table.vue";
import { useI18n } from "vue-i18n";
import commonService from "../../../Service/WithoutStockAffectService";
import { useRoute, useRouter } from "vue-router";
import { FilterMatchMode, FilterOperator } from "primevue/api";
import EditConfirmation from "../../../../../components/FormComponents/EditConfirmation.vue";
import POConfirmation from "../../../../../components/FormComponents/EditConfirmation.vue";
import DeleteConfirmationVue from "../../../../../components/FormComponents/DeleteConfirmation.vue";
import DeletedSuccessfully from "../../../../../components/FormComponents/DeletedSuccessfully.vue";
import Loader from "../../../../../components/FormComponents/Loader.vue";
import MasterEmpty from "../../../../../components/Masters/MasterEmpty.vue";
import { useToast } from "primevue/usetoast";
import { checkPermission } from "../../../Service/AccessControl";
import SkeletonTableLoader from "../../../../../components/FormComponents/SkeletonTableLoader.vue";
import MobileViewCardHeader from "../../../../../components/FormComponents/MobileViewCardHeader.vue";
import MobileLoader from "../../../../../components/SkeletonLoaderComponents/ContactCardView.vue";
import CrystalReportPrintPopUp from "../../../../../modules/Inventory/components/Print/CrystalReportPrint.vue";
import itemIssueGrnReturnFilters from "../../../../../modules/Inventory/components/Filters/itemIssueGrnReturnFilters.vue";
import moment from "moment";
import FilterForm from "../../../../../components/FormComponents/FilterForm.vue";
import ExportOption from "../../../../../components/FormComponents/Export.vue";
import poGrnFilters from "../../../../../modules/Inventory/components/Filters/poGrnFilters.vue";
import CloseConfirmation from "../../../../../components/FormComponents/CancelConfirmation.vue";
import ClosedSuccessfully from "../../../../../components/FormComponents/CancelSuccessfully.vue";
import CancelConfirmation from "../../../../../components/FormComponents/CancelConfirmation.vue";
import CancelSuccessfully from "../../../../../components/FormComponents/CancelSuccessfully.vue";
import RevertedSuccessfully from "../../../../../components/FormComponents/createdsuccessfully.vue";
import Footer from "../../../../../components/FormComponents/Footer.vue";
import Textarea from "../../../../../components/FormComponents/TextArea.vue";
import debounce from "lodash/debounce";

export default defineComponent({
  components: {
    Tableview,
    DeletedSuccessfully,
    EditConfirmation,
    DeleteConfirmationVue,
    Loader,
    MasterEmpty,
    SkeletonTableLoader,
    MobileViewCardHeader,
    MobileLoader,
    POConfirmation,
    CrystalReportPrintPopUp,
    itemIssueGrnReturnFilters,
    FilterForm,
    ExportOption,
    poGrnFilters,
    ClosedSuccessfully,
    CloseConfirmation,
    CancelConfirmation,
    CancelSuccessfully,
    RevertedSuccessfully,
    Footer,
    Textarea,
  },
  props: {
    showone: {
      type: String,
      default: "",
    },
    items: {
      type: Array,
      default: () => [],
    },
    propsParams: {
      type: Object,
    },
    FunctionRights: {
      type: Object,
    },
  },

  emits: ["row-click"],

  setup(props, { emit }) {
    let loading = ref(false);
    let showitemfield = ref(false);
    const router = useRouter();
    const generic = ref();
    let items = ref([]);
    let loading1 = ref(false);
    const ObjData = ref();
    let content = ref("");
    const toast = useToast();
    const menu = ref();
    let actionedit = ref(false);
    let actionpo = ref(false);
    const actionclose = ref(false);
    const actioncancel = ref(false);
    const actionrevert = ref(false);

    const route = useRoute();
    const deletepop = ref(false);
    const Deletemodel = ref(false);
    const Editmodel = ref(false);
    const { t } = useI18n();
    const hasData = ref(false);
    const POmodel = ref(false);
    const rowFocus = ref(false);
    let DataEdit = ref();
    const CrystalReportPopup = ref(false);
    let visible = ref(false);
    const resetfilter = ref(false);
    const ParameterValues = ref({
      Id: 0,
      BranchId: 0,
      HospitalId: 0,
    });
    const windowWidth = ref(window.innerWidth);
    const handleResize = () => {
      windowWidth.value = window.innerWidth;
    };

    const PrintType = ref({
      Type: "T",
      FormId: 41,
      HeaderTitle: "Purchase Request",
      ModuleId: 3,
    });

    let ExportList = ref([]);
    let PageName = ref("Purchase Request");
    let ExportOption = ref("");

    let Rights: any = ref({
      Create: false,
      Update: false,
      Read: false,
      Delete: false,
    });

    let ObjOperationId = ref({
      CreateId: 0,
      UpdateId: 0,
      ReadId: 0,
      DeleteId: 0,
      EntityId: 0,
    });

    let ParamValues = ref({
      StockWoTransTMId: 0,
      StoreId: 0,
      DocNo: "",
      DocType: 18,
      status: 0,
      OperationId: ObjOperationId.value.CreateId,
      EntityId: ObjOperationId.value.EntityId,
      storebranchmapid: route.query.storebranchmapid ?? 0,
      BranchId: route.query.BranchId ?? 0,
      IsDraft: 0,
      //Type: "",
    });

    let ObjCancelPopUp = ref({
      CancelReasonPopup: false,
      CancelReason: "",
      PopUpHeaderName: "",
      TextAareaName: "",
      ConfirmPopupHeader: "",
      ConfirmPopupContent: "",
    });

    const ObjCancelPR = ref({
      Id: 0,
      Status: "0",
      Amount: 0.0,
      EntityId: 0,
      EntityOperationId: 0,
      DeptRoleId: 0,
      CreatedBy: 0,
      HospitalId: 0,
      BranchId: 0,
      CancelReason: "",
      IsApproved: 0,
      Type: 0,
      StoreId: 0,
      DocNo: "",
    });

    let ObjPRClosePopUp = ref({
      Visible: false,
      ClosedReason: "",
      PopUpHeaderName: "",
      TextAareaName: "",
      ConfirmPopupHeader: "",
      ConfirmPopupContent: "",
    });

    const ObjPRClose = ref({
      Id: 0,
      Status: "0",
      Amount: 0.0,
      EntityId: 0,
      EntityOperationId: 0,
      DeptRoleId: 0,
      CreatedBy: 0,
      HospitalId: 0,
      BranchId: 0,
      ClosedReason: "",
      IsApproved: 0,
      StoreId: 0,
      DocNo: "",
    });

    const ModelPopupDunction = ref({
      CloseConfirmPop: false,
      CloseModelTxt: "",
      CloseSuccessPop: false,

      cancelmodel: false,
      CancelModelTxt: "",
      Cancelpop: false,

      Revertmodel: false,
      RevertModelTxt: "",
      Revertpop: false,
    });

    //get local storage session data
    let SessionUserData = localStorage.getItem("UsersData");
    let usersData: any;
    if (SessionUserData !== null) {
      usersData = JSON.parse(SessionUserData);
    }

    let SessionRolesData = localStorage.getItem("RolesData");
    let rolesData;
    if (SessionRolesData !== null) {
      rolesData = JSON.parse(SessionRolesData);
    }
    //

    let QueryStringValue3: any = route.query;
    ParamValues.value.StoreId = QueryStringValue3["Id"];
    ParamValues.value.status = QueryStringValue3["status"];

    const paramValue = computed(() => {
      return route.query.param as string;
    });

    let StatusFilter = {
      StatusFrom: "PR",
      Status: false,
      AprrovalStatus: true,
    };

    onMounted(() => {
      window.addEventListener("resize", handleResize);
      IsShow();
    });

    onUnmounted(() => {
      window.removeEventListener("resize", handleResize);
    });

    watch(
      props,
      (newValue: any) => {
        debugger;
        console.log("props Changed", newValue.FunctionRights);
        Rights.value.Create = newValue.FunctionRights.Create;
        Rights.value.Update = newValue.FunctionRights.Update;
        Rights.value.Read = newValue.FunctionRights.Read;
        Rights.value.Delete = newValue.FunctionRights.Delete;
        Object.keys(ObjOperationId.value).forEach((key) => {
          if (newValue.FunctionRights[key])
            ObjOperationId.value[key] = newValue.FunctionRights[key];
        });
      },
      { deep: true }
    );

    function onRowClick(event: Event, rowData: any) {
      emit("row-click", rowData);
    }

    const rowsCount = ref(0);
    const state = reactive({
      pagedItems: [], // contains a subset of rows for the current page
      currentPage: 1, // current page number
      pageSize: 10, // number of rows per page
      totalRows: 0, // total number of rows in the database
    });

    const filters = {
      global: { value: null, matchMode: FilterMatchMode.CONTAINS },
      DocDate: { value: null, matchMode: FilterMatchMode.IN, options: items },
      DocNo: {
        value: null,
        matchMode: FilterMatchMode.IN,
        options: items,
      },
      CreatedBy: {
        value: null,
        matchMode: FilterMatchMode.IN,
        options: items,
      },
      ItemCount: {
        value: null,
        matchMode: FilterMatchMode.IN,
        options: items,
      },
      Amount: {
        value: null,
        matchMode: FilterMatchMode.IN,
        options: items,
      },
      PurchaseRequestStatus: {
        value: null,
        matchMode: FilterMatchMode.IN,
        options: items,
      },
    };

    const headers = [
      {
        header: t("storetabdetails.prtable.sno"),
        field: "RowNumber",
        class: "filterdisplaynone",
      },
      {
        header: t("storetabdetails.prtable.Status"),
        field: "PurchaseRequestStatus",
        fieldDisplay: "false",
        slot: "status",
        sortable: false,
        ShowMactchMode: false,
        filterTemplate: "MultiSelect",
        class: "mediumwidth",
      },

      {
        header: t("storetabdetails.prtable.Code"),
        field: "DocNo",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "boldclass text_overflow2",
        class: "smallwidth",
      },
      {
        header: t("storetabdetails.prtable.Date"),
        field: "DocDateHR",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        class: "smallwidth",
      },
      {
        header: t("storetabdetails.prtable.FromStore"),
        field: "FromStoreName",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "text_overflow2",
        class: "mediumwidth",
      },
      {
        header: t("storetabdetails.prtable.ToStore"),
        field: "ToStoreName",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "text_overflow2",
        class: "mediumwidth",
      },
      {
        header: t("storetabdetails.prtable.RequestedBy"),
        field: "CreatedByName",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "text_overflow2",
        class: "mediumwidth",
      },
      {
        header: t("storetabdetails.prtable.ItemCount"),
        field: "ItemCount",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "right_td",
        class: "smallwidth",
      },
      {
        header: t("storetabdetails.prtable.Value"),
        field: "Amount",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "bluecolor right_td",
        class: "smallwidth",
      },
      {
        field: "",
        fieldDisplay: "false",
        header: t("storetabdetails.prtable.PendingSince"),
        slot: "waitingsince",
        sortable: false,
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        class: "smallwidth",
      },
      {
        header: t("storetabdetails.prtable.ApprovalStatus"),
        field: "",
        fieldDisplay: "false",
        slot: "ApprovalStatus",
        sortable: false,
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        class: "smallwidth",
      },
      {
        field: "action",
        header: "",
        slot: "action",
        frozencolumn: true,
        sortable: false,
        class: "filterdisplaynone last-column-position",
        fieldDisplay: "false",
      },
    ];

    const globalFilterFields = ref(headers.map((col) => col.field));

    const toggle = (event, data) => {
      debugger;
      ObjData.value = data;

      actionedit.value =
        data.Status === "0" &&
          (data.IsApproved == 0 || data.IsApproved == 3 || data.IsDraft == 1)
          ? true
          : false;

      debugger;
      actionpo.value =
        (data.Status === "0" || data.Status === "2") &&
          data.IsApproved == 1 &&
          data.IsDraft == 0
          ? true
          : false;

      actioncancel.value =
        data.Status == "0" && data.IsApproved == "1" && data.IsDraft != 1
          ? true
          : false;

      actionrevert.value =
        data.Status == "4" && data.IsApproved == "1" && data.IsDraft != 1
          ? true
          : false;

      actionclose.value =
        (data.Status == "0 " || data.Status == "2") &&
          data.IsDraft != 1 &&
          data.IsApproved == "1"
          ? true
          : false;

      menu.value.toggle(event);
    };

    const itemListed = ref([
      {
        items: [
          {
            label: "Delete",
            icon: "deleteicon pi pi-trash",
            visible: actionedit,
            command: async () => {
              Deletedata(ObjData);
            },
          },
          {
            label: "Edit",
            icon: "editicon pi pi-pencil",
            visible: actionedit,
            command: async () => {
              Editdata(ObjData);
            },
          },
          {
            label: "Convert To PO",
            icon: "editicon pi pi-pencil",
            visible: actionpo,
            command: async () => {
              POConfirmation(ObjData);
            },
          },
          {
            label: "Print",
            icon: "editicon pi pi-print",
            visible: true,
            command: async () => {
              Print(ObjData);
            },
          },
          {
            label: "Cancel",
            icon: "deleteicon pi pi-ban",
            visible: actioncancel,
            command: async () => {
              CancelPROnClick(ObjData);
            },
          },
          {
            label: "Revert",
            icon: "",
            visible: actionrevert,
            command: async () => {
              RevertPR(ObjData);
            },
          },
          {
            label: "Close",
            icon: "deleteicon pi pi-times-circle",
            visible: actionclose,
            command: async () => {
              ClosePROnClick(ObjData);
            },
          },
        ],
      },
    ]);

    // row click for table
    function RowClick(event: any) {
      debugger;
      console.log(event.data);
      router.push({
        path: "/purchaseRequestDetails",
        query: {
          PRId: event.data ? event.data["StockTransId"] : event["StockTransId"],
          storebranchmapid: QueryStringValue3["storebranchmapid"],
          BranchId: route.query.BranchId ?? 0,
        },
      });
      rowFocus.value = true;
    }

    const IsCreate = () => {
      debugger;
      let permissionResult: any = checkPermission(Rights, "Add");
      if (permissionResult.hasPermission) {
        (ParamValues.value.OperationId = ObjOperationId.value.CreateId),
          (ParamValues.value.EntityId = ObjOperationId.value.EntityId);
        ParamValues.value.IsDraft = 1;
        router.push({
          path: "/PR",

          query: {
            data: JSON.stringify(ParamValues.value),
            param: "PR",
          },
        });
      } else {
        toast.add(permissionResult.toast);
        return;
      }
    };

    // COnvert To PO
    function POConfirmation(data) {
      debugger;
      DataEdit.value = data;
      POmodel.value = true;
      content.value = "Convert To PO";
    }

    // function ConverToPO(DataEdit) {
    //   debugger;
    //   ParamValues.value.DocNo = DataEdit.value["DocNo"];
    //   ParamValues.value.StockWoTransTMId = DataEdit.value["Id"];
    //   (ParamValues.value.OperationId = 644), (ParamValues.value.EntityId = 145);
    //   router.push({
    //     path: "/PR",
    //     query: {
    //       data: JSON.stringify(ParamValues.value),
    //       param: "PO",
    //     },
    //   });
    // }
    function ConverToPO(DataEdit) {
      debugger;
      ParamValues.value.DocNo = DataEdit.value["DocNo"];
      ParamValues.value.StockWoTransTMId = DataEdit.value["Id"];
      (ParamValues.value.OperationId = 3044001), (ParamValues.value.EntityId = 3044);
      router.push({
        path: "/converttopo",
        query: {
          data: JSON.stringify(ParamValues.value),
          param: "PO",
        },
      });
    }

    function Editdata(data) {
      debugger;
      DataEdit.value = data;
      Editmodel.value = true;
    }

    function IsEdit(DataEdit) {
      debugger;
      ParamValues.value.DocNo = DataEdit.value["DocNo"];
      ParamValues.value.StockWoTransTMId = DataEdit.value["Id"];
      ParamValues.value.IsDraft = DataEdit.value["IsDraft"];
      debugger;
      (ParamValues.value.OperationId =
        DataEdit.value["IsDraft"] == 1
          ? ObjOperationId.value.CreateId
          : ObjOperationId.value.UpdateId),
        (ParamValues.value.EntityId = ObjOperationId.value.EntityId);

      router.push({
        path: "/PR",
        query: {
          data: JSON.stringify(ParamValues.value),
          param: "PR",
        },
      });
    }

    //Delete Values in Table
    function Deletedata(data) {
      debugger;
      DataEdit.value = data;
      Deletemodel.value = true;
      content.value = t("confirmation.deletecontent");
    }

    async function IsDelete(DataEdit) {
      debugger;
      console.log(DataEdit.value["StockTransId"]);
      try {
        const response = await commonService.DeleteStockWOTM(
          DataEdit.value["StockTransId"]
        );
        let msg = "";
        msg = response["ErrorInfo"].ErrorCode;
        if (msg == null) {
          Deletemodel.value = false;
          deletepop.value = true;
          IsShow();
        }
      } catch (error) {
        console.log(error);
      }
    }

    let dataValue = {
      Id: 0,
      status: 0,
      // Type: "",
    };

    watch(props, (newValue) => {
      debugger;
      Object.assign(dataValue, newValue.propsParams);
      if (dataValue.Id) {
        items.value = [];
        ParamValues.value.StoreId = dataValue.Id;
        ParamValues.value.status = dataValue.status;
        //ParamValues.value.Type = dataValue.Type;
        IsShow();
      }
    });

    function ShowRows(value) {
      debugger;
      if (value != 0 && value != null && value != undefined) {
        state.pageSize = value;
        IsShow();
      }
    }

    watch(
      [() => state.currentPage, () => state.pageSize],
      async ([pageNum, pageSize]) => {
        debugger;
        await IsShow();
      }
    );

    // Debounced search for server-side filtering
    function SearchBox(value) {
      debugger;
      if (value === "" || value.length >= 3) {
        debouncedSearch(value);
      }
    }

    const debouncedSearch = debounce((input) => {
      SearchValue.value.inputValue = input;
      state.pagedItems = [];
      state.currentPage = 1;
      state.pageSize = 10;
      state.totalRows = 0;
      IsShow();
    }, 300);

    //Get data for TableView
    async function IsShow() {
      debugger;
      try {
        loading.value =
          SearchValue.value.inputValue ||
            SearchValue.value.fromDate ||
            SearchValue.value.toDate
            ? false
            : true;

        debugger;
        const pageNum = state.currentPage;
        const pageSize = state.pageSize;
        const columnName = "";
        const columnValue = "";
        const columnName1 = "";
        const columnValue1 = "";
        const columnName2 = filterItems.value.Code ? "DocNo" : "";
        const columnValue2 = filterItems.value.Code
          ? filterItems.value.Code
          : "";
        const columnName3 = "";
        const columnValue3 = "";

        // let Condition = "sm.HospitalId=" + usersData.OrganizationId +
        //   " and sm.BranchId=" + usersData.BranchId +
        //   " and ((sm.FromStore =" + ParamValues.value.StoreId + " and sm.FromStoreBrMapId=" + StorebranchmapId + ") or (sm.ToStore=" + ParamValues.value.StoreId + " and sm.ToStoreBrMapId=" + StorebranchmapId + "))"

        // let Condition =
        //   "sm.HospitalId=" +
        //   usersData.OrganizationId +
        //   " and (COALESCE('" +
        //   usersData.BranchId +
        //   "', '0') = '0' OR sm.BranchId IN (SELECT * FROM dbo.Split('" +
        //   usersData.BranchId +
        //   "', ',')))" +
        //   " and ((sm.FromStore =" +
        //   ParamValues.value.StoreId +
        //   " and (COALESCE('" +
        //   usersData.BranchId +
        //   "', '0') = '0' OR sm.FromStoreBranchId IN(SELECT * FROM dbo.Split('" +
        //   usersData.BranchId +
        //   "', ',')))) or (sm.ToStore=" +
        //   ParamValues.value.StoreId +
        //   " and (COALESCE('" +
        //   usersData.BranchId +
        //   "', '0') = '0' OR sm.ToStoreBranchId IN(SELECT * FROM dbo.Split('" +
        //   usersData.BranchId +
        //   "', ',')))))";


        let Condition =
          "sm.HospitalId=" +
          usersData.OrganizationId +
          " and ((   isnull(sm.SOPRId,0)=0   and sm.FromStore =" +
          ParamValues.value.StoreId +
          " and (COALESCE('" +
          usersData.BranchId +
          "', '0') = '0' OR sm.FromStoreBranchId IN(SELECT * FROM dbo.Split('" +
          usersData.BranchId +
          "', ',')))) or (    ((isnull(sm.isstoresupplier,0) =0 and  isnull(sm.SOPRId,0) =0) or isnull(sm.SOPRId,0)!=0)    and sm.ToStore=" +
          ParamValues.value.StoreId +
          " and (COALESCE('" +
          usersData.BranchId +
          "', '0') = '0' OR sm.ToStoreBranchId IN(SELECT * FROM dbo.Split('" +
          usersData.BranchId +
          "', ',')))))";

        //Both  buttonFilter and ApprovalStatusIds were selected
        if (
          buttonFilter.value.Name != "" &&
          filterItems.value.ApprovalStatusIds != ""
        ) {
          if (buttonFilter.value.Name == "All") {
            if (filterItems.value.ApprovalStatusIds.includes("0")) {
              Condition =
                Condition +
                " and( sm.IsApproved  IN(" +
                filterItems.value.ApprovalStatusIds +
                "))";
            } else if (filterItems.value.ApprovalStatusIds != "") {
              Condition =
                Condition +
                " and( sm.IsApproved  IN(" +
                filterItems.value.ApprovalStatusIds +
                "))";
            }
          } else if (buttonFilter.value.Name == "Pending") {
            if (filterItems.value.ApprovalStatusIds.includes("0")) {
              Condition =
                Condition +
                " and (((SELECT Count(*)  FROM StockWOTransTM st inner join StockWODetailsTD sw on st.Id=sw.RefId WHERE st.RefId = sm.Id  AND st.DocType IN (4, 5)) = 0 and sm.status!=3)or(( SELECT COUNT(st.id) FROM StockWOTransTM st inner join StockWODetailsTD sw on st.Id=sw.RefId  WHERE st.Id = sm.Id  AND st.IsActive = 1 AND st.DocType IN (18))!=(SELECT COUNT(st.id) FROM StockWOTransTM st inner join StockWODetailsTD sw on st.Id=sw.RefId  WHERE st.RefId = sm.Id  AND st.IsActive = 1 AND st.DocType IN (4, 5) AND st.IsDraft = 0 and sw.Status=1)and( SELECT COUNT(st.id)  FROM StockWOTransTM st inner join StockWODetailsTD sw on st.Id=sw.RefId  WHERE st.Id = sm.Id  AND st.IsActive = 1 AND st.DocType IN (18) and st.Status!=0)=(SELECT COUNT(st.id) FROM StockWOTransTM st inner join StockWODetailsTD sw on st.Id=sw.RefId  WHERE st.RefId = sm.Id   AND st.IsActive = 1 AND st.DocType IN (4, 5) and st.IsDraft=0 and sw.Status=1 ))) and (( sm.IsApproved  IN(" +
                filterItems.value.ApprovalStatusIds +
                ")) or sm.IsApproved is null) ";
            } else {
              Condition =
                Condition +
                " and (((SELECT Count(*)  FROM StockWOTransTM st inner join StockWODetailsTD sw on st.Id=sw.RefId WHERE st.RefId = sm.Id  AND st.DocType IN (4, 5)) = 0 and sm.status!=3)or(( SELECT COUNT(st.id) FROM StockWOTransTM st inner join StockWODetailsTD sw on st.Id=sw.RefId  WHERE st.Id = sm.Id  AND st.IsActive = 1 AND st.DocType IN (18))!=(SELECT COUNT(st.id) FROM StockWOTransTM st inner join StockWODetailsTD sw on st.Id=sw.RefId  WHERE st.RefId = sm.Id  AND st.IsActive = 1 AND st.DocType IN (4, 5) AND st.IsDraft = 0 and sw.Status=1)and( SELECT COUNT(st.id)  FROM StockWOTransTM st inner join StockWODetailsTD sw on st.Id=sw.RefId  WHERE st.Id = sm.Id  AND st.IsActive = 1 AND st.DocType IN (18) and st.Status!=0)=(SELECT COUNT(st.id) FROM StockWOTransTM st inner join StockWODetailsTD sw on st.Id=sw.RefId  WHERE st.RefId = sm.Id   AND st.IsActive = 1 AND st.DocType IN (4, 5) and st.IsDraft=0 and sw.Status=1 ))) and( sm.IsApproved  IN(" +
                filterItems.value.ApprovalStatusIds +
                ")) ";
            }
          } else if (buttonFilter.value.Name == "Partial") {
            if (filterItems.value.ApprovalStatusIds.includes("0")) {
              Condition =
                Condition +
                " and ((SELECT Count(*)  FROM StockWOTransTM st inner join StockWODetailsTD sw on st.Id=sw.RefId WHERE st.RefId = sm.Id  AND st.DocType IN (4, 5)) > 0 )and(( SELECT COUNT(st.id) FROM StockWOTransTM st inner join StockWODetailsTD sw on st.Id=sw.RefId  WHERE st.Id = sm.Id  AND st.IsActive = 1 AND st.DocType IN (18))!=(SELECT COUNT(st.id) FROM StockWOTransTM st inner join StockWODetailsTD sw on st.Id=sw.RefId  WHERE st.RefId = sm.Id  AND st.IsActive = 1 AND st.DocType IN (4, 5) AND st.IsDraft = 0 and sw.Status=1)and( SELECT COUNT(st.id)  FROM StockWOTransTM st inner join StockWODetailsTD sw on st.Id=sw.RefId  WHERE st.Id = sm.Id  AND st.IsActive = 1 AND st.DocType IN (18) and st.Status!=0)!=(SELECT COUNT(st.id) FROM StockWOTransTM st inner join StockWODetailsTD sw on st.Id=sw.RefId  WHERE st.RefId = sm.Id   AND st.IsActive = 1 AND st.DocType IN (4, 5) and st.IsDraft=0 and sw.Status=1 )) and (( sm.IsApproved  IN(" +
                filterItems.value.ApprovalStatusIds +
                ")) or sm.IsApproved is null)";
            } else {
              Condition =
                Condition +
                " and ((SELECT Count(*)  FROM StockWOTransTM st inner join StockWODetailsTD sw on st.Id=sw.RefId WHERE st.RefId = sm.Id  AND st.DocType IN (4, 5)) > 0 )and(( SELECT COUNT(st.id) FROM StockWOTransTM st inner join StockWODetailsTD sw on st.Id=sw.RefId  WHERE st.Id = sm.Id  AND st.IsActive = 1 AND st.DocType IN (18))!=(SELECT COUNT(st.id) FROM StockWOTransTM st inner join StockWODetailsTD sw on st.Id=sw.RefId  WHERE st.RefId = sm.Id  AND st.IsActive = 1 AND st.DocType IN (4, 5) AND st.IsDraft = 0 and sw.Status=1)and( SELECT COUNT(st.id)  FROM StockWOTransTM st inner join StockWODetailsTD sw on st.Id=sw.RefId  WHERE st.Id = sm.Id  AND st.IsActive = 1 AND st.DocType IN (18) and st.Status!=0)!=(SELECT COUNT(st.id) FROM StockWOTransTM st inner join StockWODetailsTD sw on st.Id=sw.RefId  WHERE st.RefId = sm.Id   AND st.IsActive = 1 AND st.DocType IN (4, 5) and st.IsDraft=0 and sw.Status=1 )) and ( sm.IsApproved  IN(" +
                filterItems.value.ApprovalStatusIds +
                ")) ";
            }
          } else if (buttonFilter.value.Name == "Converted To PO") {
            if (filterItems.value.ApprovalStatusIds.includes("0")) {
              Condition =
                Condition +
                " and (((SELECT Count(*)  FROM StockWOTransTM st inner join StockWODetailsTD sw on st.Id=sw.RefId WHERE st.RefId = sm.Id  AND st.DocType IN (4, 5)) > 0)and(( SELECT COUNT(st.id) FROM StockWOTransTM st inner join StockWODetailsTD sw on st.Id=sw.RefId  WHERE st.Id = sm.Id  AND st.IsActive = 1 AND st.DocType IN (18))=(SELECT COUNT(st.id) FROM StockWOTransTM st inner join StockWODetailsTD sw on st.Id=sw.RefId  WHERE st.RefId = sm.Id  AND st.IsActive = 1 AND st.DocType IN (4, 5) AND st.IsDraft = 0 and sw.Status=1))) and (( sm.IsApproved  IN(" +
                filterItems.value.ApprovalStatusIds +
                ")) or sm.IsApproved is null)";
            } else {
              Condition =
                Condition +
                " and (((SELECT Count(*)  FROM StockWOTransTM st inner join StockWODetailsTD sw on st.Id=sw.RefId WHERE st.RefId = sm.Id  AND st.DocType IN (4, 5)) > 0)and(( SELECT COUNT(st.id) FROM StockWOTransTM st inner join StockWODetailsTD sw on st.Id=sw.RefId  WHERE st.Id = sm.Id  AND st.IsActive = 1 AND st.DocType IN (18))=(SELECT COUNT(st.id) FROM StockWOTransTM st inner join StockWODetailsTD sw on st.Id=sw.RefId  WHERE st.RefId = sm.Id  AND st.IsActive = 1 AND st.DocType IN (4, 5) AND st.IsDraft = 0 and sw.Status=1))) and ( sm.IsApproved  IN(" +
                filterItems.value.ApprovalStatusIds +
                "))";
            }
          }
        }
        //Only  buttonFilter  selected
        else if (
          buttonFilter.value.Name != "" &&
          buttonFilter.value.Name != "All"
        ) {
          if (buttonFilter.value.Name == "Partial") {
            Condition =
              Condition +
              " and ((SELECT Count(*)  FROM StockWOTransTM st inner join StockWODetailsTD sw on st.Id=sw.RefId WHERE st.RefId = sm.Id  AND st.DocType IN (4, 5)) > 0 )and(( SELECT COUNT(st.id) FROM StockWOTransTM st inner join StockWODetailsTD sw on st.Id=sw.RefId  WHERE st.Id = sm.Id  AND st.IsActive = 1 AND st.DocType IN (18))!=(SELECT COUNT(st.id) FROM StockWOTransTM st inner join StockWODetailsTD sw on st.Id=sw.RefId  WHERE st.RefId = sm.Id  AND st.IsActive = 1 AND st.DocType IN (4, 5) AND st.IsDraft = 0 and sw.Status=1)and( SELECT COUNT(st.id)  FROM StockWOTransTM st inner join StockWODetailsTD sw on st.Id=sw.RefId  WHERE st.Id = sm.Id  AND st.IsActive = 1 AND st.DocType IN (18) and st.Status!=0)!=(SELECT COUNT(st.id) FROM StockWOTransTM st inner join StockWODetailsTD sw on st.Id=sw.RefId  WHERE st.RefId = sm.Id   AND st.IsActive = 1 AND st.DocType IN (4, 5) and st.IsDraft=0 and sw.Status=1 ))";
          } else if (buttonFilter.value.Name == "Pending") {
            Condition =
              Condition +
              " and (((SELECT Count(*)  FROM StockWOTransTM st inner join StockWODetailsTD sw on st.Id=sw.RefId WHERE st.RefId = sm.Id  AND st.DocType IN (4, 5)) = 0 and sm.status!=3)or(( SELECT COUNT(st.id) FROM StockWOTransTM st inner join StockWODetailsTD sw on st.Id=sw.RefId  WHERE st.Id = sm.Id  AND st.IsActive = 1 AND st.DocType IN (18))!=(SELECT COUNT(st.id) FROM StockWOTransTM st inner join StockWODetailsTD sw on st.Id=sw.RefId  WHERE st.RefId = sm.Id  AND st.IsActive = 1 AND st.DocType IN (4, 5) AND st.IsDraft = 0 and sw.Status=1)and( SELECT COUNT(st.id)  FROM StockWOTransTM st inner join StockWODetailsTD sw on st.Id=sw.RefId  WHERE st.Id = sm.Id  AND st.IsActive = 1 AND st.DocType IN (18) and st.Status!=0)=(SELECT COUNT(st.id) FROM StockWOTransTM st inner join StockWODetailsTD sw on st.Id=sw.RefId  WHERE st.RefId = sm.Id   AND st.IsActive = 1 AND st.DocType IN (4, 5) and st.IsDraft=0 and sw.Status=1 ))) ";
          } else if (buttonFilter.value.Name == "Converted To PO") {
            Condition =
              Condition +
              " and (((SELECT Count(*)  FROM StockWOTransTM st inner join StockWODetailsTD sw on st.Id=sw.RefId WHERE st.RefId = sm.Id  AND st.DocType IN (4, 5)) > 0)and(( SELECT COUNT(st.id) FROM StockWOTransTM st inner join StockWODetailsTD sw on st.Id=sw.RefId  WHERE st.Id = sm.Id  AND st.IsActive = 1 AND st.DocType IN (18))=(SELECT COUNT(st.id) FROM StockWOTransTM st inner join StockWODetailsTD sw on st.Id=sw.RefId  WHERE st.RefId = sm.Id  AND st.IsActive = 1 AND st.DocType IN (4, 5) AND st.IsDraft = 0 and sw.Status=1)))";
          }
        }
        //Only  ApprovalStatusIds  selected
        else {
          if (filterItems.value.ApprovalStatusIds.includes("0")) {
            Condition =
              Condition +
              " and(( sm.IsApproved  IN(" +
              filterItems.value.ApprovalStatusIds +
              ")) or sm.IsApproved is null)";
          } else if (filterItems.value.ApprovalStatusIds != "") {
            Condition =
              Condition +
              " and( sm.IsApproved  IN(" +
              filterItems.value.ApprovalStatusIds +
              "))";
          }
        }

        let Flag = 1,
          searchOption = "";

        if (SearchValue.value.inputValue != "") {
          Flag = 2;
          searchOption = SearchValue.value.inputValue;
        }

        let response = await commonService.GetStockWOTM(
          SearchValue.value.fromDate ? SearchValue.value.fromDate : "",
          SearchValue.value.toDate ? SearchValue.value.toDate : "",
          pageSize,
          pageNum,
          18,
          columnName,
          columnValue,
          columnName1,
          columnValue1,
          columnName2,
          columnValue2,
          Flag,
          searchOption,
          columnName3,
          columnValue3,
          Condition
        );
        debugger;

        items.value = response["result"].map((item) => {
          item.Amount = Number(item.Amount).toFixed(2);
          // item.UnitRate = item.UnitRate.toFixed(2);
          // item.Rate = item.Rate.toFixed(2)
          return item;
        });

        if (items.value.length !== 0) {
          hasData.value = true;
        }

        rowsCount.value =
          response["result"].length > 0
            ? response["result"][0]["rowscount"]
            : 0;

        loading.value = false;
      } catch (error) {
        console.log(error);
      }
    }

    function ExportExcel() {
      debugger;
      ExportOption.value = "Excel";
      IsShowExport();
    }

    function ExportPDF() {
      debugger;
      ExportOption.value = "PDF";
      IsShowExport();
    }

    async function IsShowExport() {
      debugger;
      try {
        loading.value = false;

        debugger;
        const pageNum = state.currentPage;
        const pageSize = 0;
        const columnName = "StoreId";
        const columnValue = ParamValues.value.StoreId;
        const columnName1 = "";
        const columnValue1 = "";
        const columnName2 = filterItems.value.Code ? "DocNo" : "";
        const columnValue2 = filterItems.value.Code
          ? filterItems.value.Code
          : "";
        const columnName3 = "";
        const columnValue3 = "";

        // let Condition = "sm.HospitalId=" + usersData.OrganizationId + " and sm.BranchId=" + usersData.BranchId + " and ((sm.FromStore =" + ParamValues.value.StoreId + " and sm.FromStoreBrMapId=" + StorebranchmapId + ") or (sm.ToStore=" + ParamValues.value.StoreId + " and sm.ToStoreBrMapId=" + StorebranchmapId + "))"

        let Condition =
          "sm.HospitalId=" +
          usersData.OrganizationId +
          " and (COALESCE('" +
          usersData.BranchId +
          "', '0') = '0' OR sm.BranchId IN (SELECT * FROM dbo.Split('" +
          usersData.BranchId +
          "', ',')))" +
          " and ((sm.FromStore =" +
          ParamValues.value.StoreId +
          " and (COALESCE('" +
          usersData.BranchId +
          "', '0') = '0' OR sm.FromStoreBranchId IN(SELECT * FROM dbo.Split('" +
          usersData.BranchId +
          "', ',')))) or (sm.ToStore=" +
          ParamValues.value.StoreId +
          " and (COALESCE('" +
          usersData.BranchId +
          "', '0') = '0' OR sm.ToStoreBranchId IN(SELECT * FROM dbo.Split('" +
          usersData.BranchId +
          "', ',')))))";

        //Both  buttonFilter and ApprovalStatusIds were selected
        if (
          buttonFilter.value.Name != "" &&
          filterItems.value.ApprovalStatusIds != ""
        ) {
          if (buttonFilter.value.Name == "All") {
            if (filterItems.value.ApprovalStatusIds.includes("0")) {
              Condition =
                Condition +
                " and( sm.IsApproved  IN(" +
                filterItems.value.ApprovalStatusIds +
                "))";
            } else if (filterItems.value.ApprovalStatusIds != "") {
              Condition =
                Condition +
                " and( sm.IsApproved  IN(" +
                filterItems.value.ApprovalStatusIds +
                "))";
            }
          } else if (buttonFilter.value.Name == "Pending") {
            if (filterItems.value.ApprovalStatusIds.includes("0")) {
              Condition =
                Condition +
                " and (((SELECT Count(*)  FROM StockWOTransTM st inner join StockWODetailsTD sw on st.Id=sw.RefId WHERE st.RefId = sm.Id  AND st.DocType IN (4, 5)) = 0 and sm.status!=3)or(( SELECT COUNT(st.id) FROM StockWOTransTM st inner join StockWODetailsTD sw on st.Id=sw.RefId  WHERE st.Id = sm.Id  AND st.IsActive = 1 AND st.DocType IN (18))!=(SELECT COUNT(st.id) FROM StockWOTransTM st inner join StockWODetailsTD sw on st.Id=sw.RefId  WHERE st.RefId = sm.Id  AND st.IsActive = 1 AND st.DocType IN (4, 5) AND st.IsDraft = 0 and sw.Status=1)and( SELECT COUNT(st.id)  FROM StockWOTransTM st inner join StockWODetailsTD sw on st.Id=sw.RefId  WHERE st.Id = sm.Id  AND st.IsActive = 1 AND st.DocType IN (18) and st.Status!=0)=(SELECT COUNT(st.id) FROM StockWOTransTM st inner join StockWODetailsTD sw on st.Id=sw.RefId  WHERE st.RefId = sm.Id   AND st.IsActive = 1 AND st.DocType IN (4, 5) and st.IsDraft=0 and sw.Status=1 ))) and (( sm.IsApproved  IN(" +
                filterItems.value.ApprovalStatusIds +
                ")) or sm.IsApproved is null) ";
            } else {
              Condition =
                Condition +
                " and (((SELECT Count(*)  FROM StockWOTransTM st inner join StockWODetailsTD sw on st.Id=sw.RefId WHERE st.RefId = sm.Id  AND st.DocType IN (4, 5)) = 0 and sm.status!=3)or(( SELECT COUNT(st.id) FROM StockWOTransTM st inner join StockWODetailsTD sw on st.Id=sw.RefId  WHERE st.Id = sm.Id  AND st.IsActive = 1 AND st.DocType IN (18))!=(SELECT COUNT(st.id) FROM StockWOTransTM st inner join StockWODetailsTD sw on st.Id=sw.RefId  WHERE st.RefId = sm.Id  AND st.IsActive = 1 AND st.DocType IN (4, 5) AND st.IsDraft = 0 and sw.Status=1)and( SELECT COUNT(st.id)  FROM StockWOTransTM st inner join StockWODetailsTD sw on st.Id=sw.RefId  WHERE st.Id = sm.Id  AND st.IsActive = 1 AND st.DocType IN (18) and st.Status!=0)=(SELECT COUNT(st.id) FROM StockWOTransTM st inner join StockWODetailsTD sw on st.Id=sw.RefId  WHERE st.RefId = sm.Id   AND st.IsActive = 1 AND st.DocType IN (4, 5) and st.IsDraft=0 and sw.Status=1 ))) and( sm.IsApproved  IN(" +
                filterItems.value.ApprovalStatusIds +
                ")) ";
            }
          } else if (buttonFilter.value.Name == "Partial") {
            if (filterItems.value.ApprovalStatusIds.includes("0")) {
              Condition =
                Condition +
                " and ((SELECT Count(*)  FROM StockWOTransTM st inner join StockWODetailsTD sw on st.Id=sw.RefId WHERE st.RefId = sm.Id  AND st.DocType IN (4, 5)) > 0 )and(( SELECT COUNT(st.id) FROM StockWOTransTM st inner join StockWODetailsTD sw on st.Id=sw.RefId  WHERE st.Id = sm.Id  AND st.IsActive = 1 AND st.DocType IN (18))!=(SELECT COUNT(st.id) FROM StockWOTransTM st inner join StockWODetailsTD sw on st.Id=sw.RefId  WHERE st.RefId = sm.Id  AND st.IsActive = 1 AND st.DocType IN (4, 5) AND st.IsDraft = 0 and sw.Status=1)and( SELECT COUNT(st.id)  FROM StockWOTransTM st inner join StockWODetailsTD sw on st.Id=sw.RefId  WHERE st.Id = sm.Id  AND st.IsActive = 1 AND st.DocType IN (18) and st.Status!=0)!=(SELECT COUNT(st.id) FROM StockWOTransTM st inner join StockWODetailsTD sw on st.Id=sw.RefId  WHERE st.RefId = sm.Id   AND st.IsActive = 1 AND st.DocType IN (4, 5) and st.IsDraft=0 and sw.Status=1 )) and (( sm.IsApproved  IN(" +
                filterItems.value.ApprovalStatusIds +
                ")) or sm.IsApproved is null)";
            } else {
              Condition =
                Condition +
                " and ((SELECT Count(*)  FROM StockWOTransTM st inner join StockWODetailsTD sw on st.Id=sw.RefId WHERE st.RefId = sm.Id  AND st.DocType IN (4, 5)) > 0 )and(( SELECT COUNT(st.id) FROM StockWOTransTM st inner join StockWODetailsTD sw on st.Id=sw.RefId  WHERE st.Id = sm.Id  AND st.IsActive = 1 AND st.DocType IN (18))!=(SELECT COUNT(st.id) FROM StockWOTransTM st inner join StockWODetailsTD sw on st.Id=sw.RefId  WHERE st.RefId = sm.Id  AND st.IsActive = 1 AND st.DocType IN (4, 5) AND st.IsDraft = 0 and sw.Status=1)and( SELECT COUNT(st.id)  FROM StockWOTransTM st inner join StockWODetailsTD sw on st.Id=sw.RefId  WHERE st.Id = sm.Id  AND st.IsActive = 1 AND st.DocType IN (18) and st.Status!=0)!=(SELECT COUNT(st.id) FROM StockWOTransTM st inner join StockWODetailsTD sw on st.Id=sw.RefId  WHERE st.RefId = sm.Id   AND st.IsActive = 1 AND st.DocType IN (4, 5) and st.IsDraft=0 and sw.Status=1 )) and ( sm.IsApproved  IN(" +
                filterItems.value.ApprovalStatusIds +
                ")) ";
            }
          } else if (buttonFilter.value.Name == "Converted To PO") {
            if (filterItems.value.ApprovalStatusIds.includes("0")) {
              Condition =
                Condition +
                " and (((SELECT Count(*)  FROM StockWOTransTM st inner join StockWODetailsTD sw on st.Id=sw.RefId WHERE st.RefId = sm.Id  AND st.DocType IN (4, 5)) > 0)and(( SELECT COUNT(st.id) FROM StockWOTransTM st inner join StockWODetailsTD sw on st.Id=sw.RefId  WHERE st.Id = sm.Id  AND st.IsActive = 1 AND st.DocType IN (18))=(SELECT COUNT(st.id) FROM StockWOTransTM st inner join StockWODetailsTD sw on st.Id=sw.RefId  WHERE st.RefId = sm.Id  AND st.IsActive = 1 AND st.DocType IN (4, 5) AND st.IsDraft = 0 and sw.Status=1))) and (( sm.IsApproved  IN(" +
                filterItems.value.ApprovalStatusIds +
                ")) or sm.IsApproved is null)";
            } else {
              Condition =
                Condition +
                " and (((SELECT Count(*)  FROM StockWOTransTM st inner join StockWODetailsTD sw on st.Id=sw.RefId WHERE st.RefId = sm.Id  AND st.DocType IN (4, 5)) > 0)and(( SELECT COUNT(st.id) FROM StockWOTransTM st inner join StockWODetailsTD sw on st.Id=sw.RefId  WHERE st.Id = sm.Id  AND st.IsActive = 1 AND st.DocType IN (18))=(SELECT COUNT(st.id) FROM StockWOTransTM st inner join StockWODetailsTD sw on st.Id=sw.RefId  WHERE st.RefId = sm.Id  AND st.IsActive = 1 AND st.DocType IN (4, 5) AND st.IsDraft = 0 and sw.Status=1))) and ( sm.IsApproved  IN(" +
                filterItems.value.ApprovalStatusIds +
                "))";
            }
          }
        }
        //Only  buttonFilter  selected
        else if (
          buttonFilter.value.Name != "" &&
          buttonFilter.value.Name != "All"
        ) {
          if (buttonFilter.value.Name == "Partial") {
            Condition =
              Condition +
              " and ((SELECT Count(*)  FROM StockWOTransTM st inner join StockWODetailsTD sw on st.Id=sw.RefId WHERE st.RefId = sm.Id  AND st.DocType IN (4, 5)) > 0 )and(( SELECT COUNT(st.id) FROM StockWOTransTM st inner join StockWODetailsTD sw on st.Id=sw.RefId  WHERE st.Id = sm.Id  AND st.IsActive = 1 AND st.DocType IN (18))!=(SELECT COUNT(st.id) FROM StockWOTransTM st inner join StockWODetailsTD sw on st.Id=sw.RefId  WHERE st.RefId = sm.Id  AND st.IsActive = 1 AND st.DocType IN (4, 5) AND st.IsDraft = 0 and sw.Status=1)and( SELECT COUNT(st.id)  FROM StockWOTransTM st inner join StockWODetailsTD sw on st.Id=sw.RefId  WHERE st.Id = sm.Id  AND st.IsActive = 1 AND st.DocType IN (18) and st.Status!=0)!=(SELECT COUNT(st.id) FROM StockWOTransTM st inner join StockWODetailsTD sw on st.Id=sw.RefId  WHERE st.RefId = sm.Id   AND st.IsActive = 1 AND st.DocType IN (4, 5) and st.IsDraft=0 and sw.Status=1 ))";
          } else if (buttonFilter.value.Name == "Pending") {
            Condition =
              Condition +
              " and (((SELECT Count(*)  FROM StockWOTransTM st inner join StockWODetailsTD sw on st.Id=sw.RefId WHERE st.RefId = sm.Id  AND st.DocType IN (4, 5)) = 0 and sm.status!=3)or(( SELECT COUNT(st.id) FROM StockWOTransTM st inner join StockWODetailsTD sw on st.Id=sw.RefId  WHERE st.Id = sm.Id  AND st.IsActive = 1 AND st.DocType IN (18))!=(SELECT COUNT(st.id) FROM StockWOTransTM st inner join StockWODetailsTD sw on st.Id=sw.RefId  WHERE st.RefId = sm.Id  AND st.IsActive = 1 AND st.DocType IN (4, 5) AND st.IsDraft = 0 and sw.Status=1)and( SELECT COUNT(st.id)  FROM StockWOTransTM st inner join StockWODetailsTD sw on st.Id=sw.RefId  WHERE st.Id = sm.Id  AND st.IsActive = 1 AND st.DocType IN (18) and st.Status!=0)=(SELECT COUNT(st.id) FROM StockWOTransTM st inner join StockWODetailsTD sw on st.Id=sw.RefId  WHERE st.RefId = sm.Id   AND st.IsActive = 1 AND st.DocType IN (4, 5) and st.IsDraft=0 and sw.Status=1 ))) ";
          } else if (buttonFilter.value.Name == "Converted To PO") {
            Condition =
              Condition +
              " and (((SELECT Count(*)  FROM StockWOTransTM st inner join StockWODetailsTD sw on st.Id=sw.RefId WHERE st.RefId = sm.Id  AND st.DocType IN (4, 5)) > 0)and(( SELECT COUNT(st.id) FROM StockWOTransTM st inner join StockWODetailsTD sw on st.Id=sw.RefId  WHERE st.Id = sm.Id  AND st.IsActive = 1 AND st.DocType IN (18))=(SELECT COUNT(st.id) FROM StockWOTransTM st inner join StockWODetailsTD sw on st.Id=sw.RefId  WHERE st.RefId = sm.Id  AND st.IsActive = 1 AND st.DocType IN (4, 5) AND st.IsDraft = 0 and sw.Status=1)))";
          }
        }
        //Only  ApprovalStatusIds  selected
        else {
          if (filterItems.value.ApprovalStatusIds.includes("0")) {
            Condition =
              Condition +
              " and(( sm.IsApproved  IN(" +
              filterItems.value.ApprovalStatusIds +
              ")) or sm.IsApproved is null)";
          } else if (filterItems.value.ApprovalStatusIds != "") {
            Condition =
              Condition +
              " and( sm.IsApproved  IN(" +
              filterItems.value.ApprovalStatusIds +
              "))";
          }
        }

        let Flag = 1,
          searchOption = "";

        if (SearchValue.value.inputValue != "") {
          Flag = 2;
          searchOption = SearchValue.value.inputValue;
        }

        let response = await commonService.GetStockWOTM(
          SearchValue.value.fromDate ? SearchValue.value.fromDate : "",
          SearchValue.value.toDate ? SearchValue.value.toDate : "",
          pageSize,
          pageNum,
          18,
          columnName,
          columnValue,
          columnName1,
          columnValue1,
          columnName2,
          columnValue2,
          Flag,
          searchOption,
          columnName3,
          columnValue3,
          Condition
        );

        response["result"] = response["result"].map((item) => {
          item.Amount = Number(item.Amount).toFixed(2);
          return item;
        });

        rowsCount.value =
          response["result"].length > 0
            ? response["result"][0]["rowscount"]
            : 0;

        ExportList.value = response["result"].map((item) => {
          const filteredItem = {};

          headers.forEach(({ header, field }) => {
            filteredItem[header] = item[field];
          });

          return filteredItem;
        });

        loading.value = false;
      } catch (error) {
        console.log(error);
      }
    }

    function Print(ObjData) {
      debugger;
      CrystalReportPopup.value = true;

      ParameterValues.value.Id = ObjData.value.Id;
      ParameterValues.value.BranchId = ObjData.value.BranchId;
      ParameterValues.value.HospitalId = ObjData.value.HospitalId;
    }

    const hidepopup = () => {
      CrystalReportPopup.value = false;
    };

    let FilterLoading = ref(true);
    const filtervisible = ref(false);
    let filterItemsArray: any = ref([]);

    let filterItems = ref({
      Date: "",
      Code: "",
      StatusName: "",
      StatusIds: "",
      ApprovalStatusNames: "",
      ApprovalStatusIds: "",
    });

    let emitedfilterItems = ref({
      Code: "",
      StatusName: "",
      StatusIds: "",
      ApprovalStatusNames: "",
      ApprovalStatusIds: "",
    });

    let SearchValue = ref({
      inputValue: "",
      fromDate: "",
      toDate: "",
    });

    const removechipvalue = ref(0);

    const Emitcode = (data) => {
      emitedfilterItems.value.Code = data;
    };

    const EmitStatus = (data) => {
      emitedfilterItems.value.StatusName = data;
    };

    const EmitStatusId = (data) => {
      emitedfilterItems.value.StatusIds = data;
    };

    const EmitAppstatus = (data) => {
      emitedfilterItems.value.ApprovalStatusNames = data;
    };

    const EmitApprovalStatusIds = (data) => {
      emitedfilterItems.value.ApprovalStatusIds = data;
    };

    function Filter(values) {
      debugger;
      if (
        values.fromdate !== undefined &&
        values.fromdate !== "" &&
        values.todate !== undefined &&
        values.todate !== ""
      ) {
        filterItems.value.Date =
          moment(values.fromdate).format("DD MMM YY") +
          " To " +
          moment(values.todate).format("DD MMM YY");
      } else if (values.fromdate !== undefined && values.fromdate !== "") {
        filterItems.value.Date = moment(values.fromdate).format("DD MMM YY");
      } else if (values.todate !== undefined && values.todate !== "") {
        filterItems.value.Date = moment(values.todate).format("DD MMM YY");
      } else {
        filterItems.value.Date = "";
      }

      filterItems.value.Code = emitedfilterItems.value.Code;
      filterItems.value.StatusName = emitedfilterItems.value.StatusName;
      filterItems.value.StatusIds = emitedfilterItems.value.StatusIds;
      filterItems.value.ApprovalStatusNames =
        emitedfilterItems.value.ApprovalStatusNames;
      filterItems.value.ApprovalStatusIds =
        emitedfilterItems.value.ApprovalStatusIds;

      filterItemsArray.value = [];

      filterItemsArray.value.push(filterItems.value);

      SearchDate(values.fromdate, values.todate);
      removechipvalue.value = 0;
      filtervisible.value = false;
    }

    function ResetFilter(values) {
      debugger;
      SearchValue.value.fromDate = "";
      SearchValue.value.toDate = "";
      removechipvalue.value = 3;
      filterItems.value.Code = "";
      filterItems.value.StatusName = "";
      filterItems.value.StatusIds = "";
      filterItems.value.ApprovalStatusNames = "";
      filterItems.value.ApprovalStatusIds = "";
      state.pagedItems = [];
      state.currentPage = 1;
      state.pageSize = 10;
      state.totalRows = 0;
      filterItemsArray.value = [];
      filterItems.value.Date = "";
      resetfilter.value = resetfilter.value == true ? false : true;
      IsShow();
    }
    function SearchDate(fromDate, ToDate) {
      debugger;
      SearchValue.value.fromDate = fromDate
        ? moment(fromDate).format("YYYY-MM-DD")
        : "";
      SearchValue.value.toDate = ToDate
        ? moment(ToDate).format("YYYY-MM-DD")
        : "";

      state.pagedItems = [];
      state.currentPage = 1;
      state.pageSize = 10;
      state.totalRows = 0;
      IsShow();
    }

    const removeChip = (data) => {
      debugger;
      if (data == "Date") {
        SearchValue.value.fromDate = "";
        SearchValue.value.toDate = "";
      } else if (data == "Code") {
        removechipvalue.value = 1;
      } else if (data == "StatusName") {
        filterItems.value.StatusIds = "";
        removechipvalue.value = 3;
      } else if (data == "ApprovalStatusNames") {
        filterItems.value.ApprovalStatusIds = "";
        removechipvalue.value = 4;
      }
      filterItems.value[data] = ""; // Clear the value in the filterItems object
      IsShow();
    };

    const waitingtime = (targetDate) => {
      const currentDate = new Date().getTime(); // Convert Date to number (timestamp)
      const targetDateTime = new Date(targetDate).getTime(); // Convert Date to number (timestamp)
      const differenceInTime = Math.abs(currentDate - targetDateTime);

      const differenceInDays = Math.floor(
        differenceInTime / (1000 * 3600 * 24)
      );
      const differenceInMonths = Math.floor(differenceInDays / 30);
      const differenceInYears = Math.floor(differenceInDays / 365);

      const years =
        differenceInYears > 0
          ? `${differenceInYears} Year${differenceInYears > 1 ? "s" : ""}`
          : "";
      const months =
        differenceInMonths % 12 > 0
          ? `${differenceInMonths % 12} Month${differenceInMonths % 12 > 1 ? "s" : ""
          }`
          : "";
      const days =
        differenceInDays % 30 > 0
          ? `${differenceInDays % 30} Day${differenceInDays % 30 > 1 ? "s" : ""
          }`
          : "";

      // If the difference is exactly 0 days, return "0 days"
      if (differenceInDays === 0) {
        return "0 Day";
      }

      return `${years} ${months} ${days}`.trim();
    };

    function CancelPROnClick(data) {
      debugger;

      ObjCancelPopUp.value.PopUpHeaderName = t("confirmation.cancelpr");
      ObjCancelPopUp.value.TextAareaName = t("confirmation.cancelreason");
      ObjCancelPopUp.value.CancelReason = "";

      ObjCancelPopUp.value.CancelReasonPopup = true;

      ObjCancelPR.value.EntityId = data.value.EntityId;
      ObjCancelPR.value.EntityOperationId = 3069006;
      ObjCancelPR.value.Status = "4";
      ObjCancelPR.value.IsApproved = 0;
      ObjCancelPR.value.Type = 1;
      ObjCancelPR.value.DocNo = data.value.DocNo;

      ObjCancelPopUp.value.ConfirmPopupHeader = t("confirmation.confirmcancel");
      ObjCancelPopUp.value.ConfirmPopupContent = t(
        "confirmation.doyouwanttocancel"
      );

      ObjCancelPR.value.Id = data.value.Id;
      ObjCancelPR.value.BranchId = data.value.BranchId;
      ObjCancelPR.value.HospitalId = data.value.HospitalId;
      ObjCancelPR.value.StoreId = data.value.StoreId;
    }

    function RevertPR(data) {
      debugger;

      ObjCancelPopUp.value.PopUpHeaderName = t("confirmation.revertreason");
      ObjCancelPopUp.value.TextAareaName = t("confirmation.doyouwanttocancel");
      ObjCancelPopUp.value.CancelReason = "";

      ObjCancelPopUp.value.CancelReasonPopup = true;

      ObjCancelPR.value.EntityId = data.value.EntityId;
      ObjCancelPR.value.EntityOperationId = 3069007;
      ObjCancelPR.value.Status = "0";
      ObjCancelPR.value.IsApproved = 0;
      ObjCancelPR.value.Type = 2;
      ObjCancelPR.value.DocNo = data.value.DocNo;

      ObjCancelPopUp.value.ConfirmPopupHeader = t("confirmation.conformrevert");
      ObjCancelPopUp.value.ConfirmPopupContent = t(
        "confirmation.doyouwanttorevert"
      );

      ObjCancelPR.value.Id = data.value.Id;
      ObjCancelPR.value.BranchId = data.value.BranchId;
      ObjCancelPR.value.HospitalId = data.value.HospitalId;
      ObjCancelPR.value.StoreId = data.value.StoreId;
    }

    function SaveCancelPR() {
      debugger;
      if (ObjCancelPopUp.value.CancelReason == "") {
        toast.add({
          severity: "info",
          summary: "Enter Reason",
          detail: "",
          life: 3000,
        });
      } else {
        ModelPopupDunction.value.cancelmodel = true;
      }
    }

    const UpdateCancelStatus = async () => {
      debugger;
      try {
        ObjCancelPR.value.CancelReason = ObjCancelPopUp.value.CancelReason;

        ObjCancelPR.value.DeptRoleId = rolesData.DeptRoleMapId;

        const response = await commonService.StockWOOutStatusChanged(
          ObjCancelPR.value
        );

        let message = response["ErrorInfo"].ErrorCode;

        if (message == null) {
          ModelPopupDunction.value.cancelmodel = false;
          if (ObjCancelPR.value.EntityOperationId == 3069006) {
            ModelPopupDunction.value.CancelModelTxt = t(
              "confirmation.prcancelsuccess"
            );
            ModelPopupDunction.value.Cancelpop = true;
          } else if (ObjCancelPR.value.EntityOperationId == 3069007) {
            ModelPopupDunction.value.RevertModelTxt = t(
              "confirmation.Prrevertedsuccessfully"
            );
            ModelPopupDunction.value.Revertpop = true;
          }
        } else {
          alert("Somthing went wrong");
        }
      } catch (error) {
        console.log(error);
      }
    };

    function ClosePROnClick(data) {
      debugger;

      ObjPRClosePopUp.value.PopUpHeaderName = t("confirmation.closepr");
      ObjPRClosePopUp.value.TextAareaName = t("confirmation.EnterReason");
      ObjPRClosePopUp.value.ClosedReason = "";

      ObjPRClosePopUp.value.Visible = true;

      ObjPRClose.value.EntityId = data.value.EntityId;
      ObjPRClose.value.EntityOperationId = 3069005;
      ObjPRClose.value.DeptRoleId = rolesData.DeptRoleMapId;
      ObjPRClose.value.Id = data.value.Id;
      ObjPRClose.value.Status = "3";
      ObjPRClose.value.IsApproved = 0;
      ObjPRClose.value.DocNo = data.value.DocNo;

      ObjPRClose.value.CreatedBy = usersData.UserId;
      ObjPRClose.value.BranchId = data.value.BranchId;
      ObjPRClose.value.HospitalId = data.value.HospitalId;
      ObjPRClose.value.StoreId = data.value.StoreId;

      ObjPRClosePopUp.value.ConfirmPopupHeader = t("confirmation.confirmclose");
      ObjPRClosePopUp.value.ConfirmPopupContent = t(
        "confirmation.Doyouwanttoclose"
      );
    }

    function SaveClosePR() {
      debugger;
      if (ObjPRClosePopUp.value.ClosedReason == "") {
        toast.add({
          severity: "info",
          summary: "Enter Reason",
          detail: "",
          life: 3000,
        });
      } else {
        ModelPopupDunction.value.CloseConfirmPop = true;
      }
    }

    async function UpdateCloseStatus() {
      debugger;
      try {
        ObjPRClose.value.ClosedReason = ObjPRClosePopUp.value.ClosedReason;

        const response = await commonService.UpdateCloseStatus(
          ObjPRClose.value
        );

        let message = response["ErrorInfo"].ErrorCode;

        if (message == null) {
          ModelPopupDunction.value.CloseConfirmPop = false;
          ModelPopupDunction.value.CloseModelTxt = t(
            "confirmation.prclosedsuccess"
          );
          ModelPopupDunction.value.CloseSuccessPop = true;
        } else {
          alert("Somthing went wrong");
        }
      } catch (error) {
        console.log(error);
      }
    }

    function Close() {
      ModelPopupDunction.value.CloseSuccessPop = false;
      ObjPRClosePopUp.value.Visible = false;
      IsShow();
    }

    function cancelclose() {
      debugger;
      ModelPopupDunction.value.Cancelpop = false;
      ModelPopupDunction.value.Revertpop = false;
      ObjCancelPopUp.value.CancelReasonPopup = false;
      IsShow();
    }

    const filterStatus = [
      { id: 10, name: "All" },
      { id: 0, name: "Pending" },
      { id: 2, name: "Partial" },
      { id: 1, name: "Converted To PO" },
    ];
    const selectedStatus = ref(10);
    let buttonFilter = ref({
      Id: 0,
      Name: "",
    });
    const selectStatus = (id, name) => {
      debugger;
      selectedStatus.value = id;
      buttonFilter.value.Id = id;
      buttonFilter.value.Name = name;
      IsShow();
    };

    return {
      selectStatus,
      selectedStatus,
      filterStatus,
      showitemfield,
      items,
      headers,
      loading,
      paramValue,
      onRowClick,
      IsShow,
      IsEdit,
      IsDelete,
      IsCreate,
      loading1,
      globalFilterFields,
      filters,
      Editdata,
      Deletedata,
      Deletemodel,
      deletepop,
      Editmodel,
      RowClick,
      DataEdit,
      rowsCount,
      state,
      menu,
      toggle,
      itemListed,
      content,
      POmodel,
      ConverToPO,
      CrystalReportPopup,
      ParameterValues,
      PrintType,
      hidepopup,
      Filter,
      ResetFilter,
      filterItemsArray,
      filtervisible,
      SearchValue,
      FilterLoading,
      Emitcode,
      removeChip,
      removechipvalue,
      SearchBox,
      ExportOption,
      ExportList,
      PageName,
      ExportExcel,
      ExportPDF,
      ShowRows,
      windowWidth,
      visible,
      waitingtime,
      EmitStatus,
      EmitStatusId,
      EmitAppstatus,
      EmitApprovalStatusIds,
      StatusFilter,
      resetfilter,
      ObjPRClosePopUp,
      SaveClosePR,
      ModelPopupDunction,
      Close,
      UpdateCloseStatus,
      ObjCancelPopUp,
      SaveCancelPR,
      RevertPR,
      cancelclose,
      UpdateCancelStatus,
      hasData,
    };
  },
});
</script>
